import React, { Component } from "react";

import DeckListView from "./DeckListView";
import { Link, withRouter } from 'react-router-dom';
import { Button, Badge, Collapse, UncontrolledTooltip } from 'reactstrap';
import { db, firebase } from '../firebase';
import PropTypes from 'prop-types';
import DeckComments from './DeckComments';
import _ from 'lodash';
import * as routes from '../Constants/routes';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import AdChitika from "../Ads/AdChitika";

class DeckView extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      deckId: this.props.match.params.deckId,
      decklist: [],
      deckCount: 0,
      nanoCost: 0,
      decks: [],
      saveform: false,
      deckName: "",
      author: "",
      description: "",
      preview: false,
      previewCard: "",
      addDate: new Date(),
      upVotes: 0,
      voters: [],
      votedUp: true,
      votedDown: true,
      favorites: this.context.favorites,
      favoriteColor: "secondary",
      aspects: [],
      authorId: "",
      comments: []
    }

    this.cardPreview = this.cardPreview.bind(this);
    this.vote = this.vote.bind(this);
    this.favorite = this.favorite.bind(this);
    this.edit = this.edit.bind(this);
    this.postHandler = this.postHandler.bind(this);
  }

  componentDidMount () {
      var deck = this.state.deckId;
      var thethis = this;

      db.getDeck(deck).then(snapshot =>
        thethis.setState(() =>
        (
          { decklist: snapshot.cards,
            deckName: snapshot.deckName,
            deckCount:snapshot.cardCount,
            nanoCost: snapshot.nanoCost,
            author: snapshot.author,
            description: snapshot.description,
            addDate: ("addDate" in snapshot ? snapshot.addDate : new Date()),
            upVotes: ("upVotes" in snapshot ? snapshot.upVotes : 0),
            voters: ("voters" in snapshot ? snapshot.voters : []),
            aspects: ("aspects" in snapshot ? snapshot.aspects : []),
            authorId: ("authorId" in snapshot ? snapshot.authorId: ""),
            comments: ("Comments" in snapshot ? snapshot.Comments: [])
          }))
      ).then(() => {
            var user = this.context.authUserId;
            var voters = this.state.voters;
            var votes = this.state.upVotes;

            var result = _.find(voters, { "voter": user });
            if (result)
            {
              _.forOwn(voters, function(value, key) {
                if (value.voter == user) {
                    if (value.vote == "up") {
                      thethis.setState({votedDown: false})
                    } else {
                      thethis.setState({votedUp: false})
                    }
                }
              });
            } else {
                if (this.context.authUser){
                thethis.setState({votedUp: false, votedDown: false})
              }
            }
      })

      var favResult = _.find(this.state.favorites, {"deckId": deck })
      if (favResult)
      {
        this.setState({favoriteColor: "danger"})
      }
    }

    cardPreview(card) {
        console.log("this is your card " + card )
        if (this.state.preview) {
          this.setState({preview: false})
        }
        else {
          this.setState({preview: true})
        }

        this.setState({previewCard: card})

    }

    vote = (thevote) => (e) => {
      var deck = this.state.deckId;
      var user = this.context.authUserId;
      var voters = this.state.voters;
      var votes = this.state.upVotes;

      var result = _.find(voters, { "voter": user });
      if (result)
      {
        _.forOwn(voters, function(value, key) {
          if (value.voter == user) {
              if (value.vote == "up") {
                  value.vote = "down";
                  votes = votes -2;
              } else {
                value.vote = "up";
                votes = votes +2;
              }
          }
        });
      } else {
        if (thevote == "up"){
          votes = votes + 1
        } else {
          votes = votes -1
        }

        voters.push({'voter': user, 'vote': thevote});
      }

      db.upVoteDeck(deck, votes, voters)
      .then(() => {
        this.setState(() => ({upVotes: votes, voters: voters}));

        if (thevote == "up"){
          this.setState(() => ({votedUp: true, votedDown: false}));
        } else {
          this.setState(() => ({votedUp: false, votedDown: true}));
        }


      })

    }

    favorite(event){
      var favColor = this.state.favoriteColor;
      var user = this.context.authUserId;
      var faves = this.state.favorites;
      var deck = this.state.deckId;

      var favoritesObj = {deckId: this.state.deckId, deckName: this.state.deckName, author: this.state.author, aspects: this.state.aspects }



      if (favColor == "danger"){
        var updatedFaves = faves.filter(function (d) {
            return (d.deckId != deck);
        });

        db.updateUserFavorites(user, updatedFaves)
          .then(() => {
            this.setState(() => ({ favoriteColor: "secondary" }));
          })


      } else {

        faves.push(favoritesObj);

        db.updateUserFavorites(user, faves)
          .then(() => {
            this.setState(() => ({ favoriteColor: "danger" }));
          })
      }
    }

    edit(event){
      var thethis = this;
      var queryV = '?query=' + thethis.state.deckId;
      this.props.history.push({
        pathname: routes.DECKBUILDERV2,
        search: queryV
      });
    }

    postHandler (comments) {
        this.setState({commentData: comments})
    }

    render() {


      var deckSectionStyle = {

        justifyContent: "center",
        backgroundColor: "white"
      }

      var deckStyle = {
        maxWidth: 500,
        marginTop: 10
      }

      var titleStyle = {
        fontFamily: "Audiowide, cursive",
        color: "cadetblue"
      }

      var size14 = {
        fontSize: 14
      }

      var adStyle={
        marginTop:60,
        justifyContent: "center"
      }

      var favoriteIcon = <i color="red" className="fas fa-heart"></i>;

      return (
        <React.Fragment>
        <div className="Site-content">
        <div style={adStyle} className="row">
        <AdChitika publisher="Gaztingo" />
        </div>
          <div className="container rounded" style={deckSectionStyle}>
            <div className="row">

              <div className="col-12 col-md-6 col-lg-6 col-xl-6 mt-1">
                <h3 style={titleStyle}>{this.state.deckName}</h3>
                <p style={size14}>Author: {this.state.author} &nbsp; &nbsp; Created: {this.state.addDate.toLocaleDateString()} </p>
              </div>


              <div className="col-12 col-md-6 col-lg-6 col-xl-6 mt-1">
                <h3>
                  <Button disabled={(this.context.authUser ? false : true)} color={this.state.favoriteColor} id="favoriteButton" onClick={this.favorite}>
                    <i className="far fa-heart"></i>
                  </Button>
                  <UncontrolledTooltip placement="right" target="favoriteButton">
                    Favorite this deck.
                  </UncontrolledTooltip>
                  <Button id="upvoteButton" disabled={(!this.context.authUser ? true : this.state.votedUp)} onClick={this.vote("up")} className="ml-2 mr-2"><i className="fas fa-thumbs-up"></i></Button>
                  <UncontrolledTooltip placement="right" target="upvoteButton">
                    Up vote this deck.
                  </UncontrolledTooltip>
                  {this.state.upVotes}
                  <Button id="downvoteButton" disabled={(!this.context.authUser ? true : this.state.votedDown)} onClick={this.vote("down")} className="ml-2"><i className="fas fa-thumbs-down"></i></Button>
                  <UncontrolledTooltip placement="right" target="downvoteButton">
                    Down vote this deck.
                  </UncontrolledTooltip>
                  <Button className={"float-right " + (this.context.authUser && this.context.authUserId == this.state.authorId ? "invisible" : "invisible") } id="delete">Delete</Button>
                  <Button onClick={this.edit} className={"mr-2 float-right " + (this.context.authUser && this.context.authUserId == this.state.authorId ? "visible" : "invisible") } id="edit">Edit</Button>

                  </h3>
                { this.context.authUser ? <p></p> :
                  <p style={size14}>  Please <Link to={routes.LOGIN}>Log In</Link> to vote on, or favorite this deck. </p>
                }

              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-1">
                <p><strong> Description: </strong></p>
                <ReactQuill id="description" value={this.state.description} readOnly={true} theme="bubble" />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-1">
                  <DeckListView decklist={this.state.decklist} deckcount={this.state.deckCount} cardPreview={this.cardPreview}
                  clickHandler={this.removecard} deckDetailsHandler={this.state.deckDetailsDisplay} nanoCost={this.state.nanoCost}
                  preview={this.state.preview} previewCard={this.state.previewCard} />
              </div>
            </div>

          </div>





          <div className="container rounded mt-1" >
            <div className="row">
              <DeckComments deckId={this.state.deckId} comments={this.state.comments} postHandler={this.postHandler} />
            </div>
          </div>
        </div>

        </ React.Fragment>
      );
    }
  }

DeckView.contextTypes = {
  authUser: PropTypes.object,
  userName: PropTypes.string,
  inGameName: PropTypes.string,
  displayIGN: PropTypes.bool,
  authUserId: PropTypes.string,
  favorites: PropTypes.array
};

export default withRouter(DeckView);



/*
  load(event){

          var docRef = firebasedb.db.collection("deckDetails").doc("eeHu6fck0If4BJ680YaN");
          var test = [];
          var the = this;
          docRef.get().then(function(doc) {
              if (doc.exists) {
                var deckDetails = doc.data().cards;
                test = [];
                _.forOwn(deckDetails, function(value, key) {
                  test.push({ 'CardQty': value.CardQty, 'CardId': value.CardId, 'CardCost': value.CardCost, 'CardName': value.CardName, 'RarityIcon': value.RarityIcon, 'AspectIcon': value.AspectIcon });

                } );
                  the.stateupdate(test);
                  console.log("Document data:", doc.data());
              } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
              }
          }).catch(function(error) {
              console.log("Error getting document:", error);
          });

  }
*/



// WEBPACK FOOTER //
// ./src/DBV2/DeckView.js